import logo from "../../assets/logo.png";
import tick from "../../assets/tick.svg";
import cornerone from "../../assets/corner-one.svg";
import cornertwo from "../../assets/corner-two.svg";
import cornerthree from "../../assets/corner-three.svg";
import { Link, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Dropdown, } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import {
  checkEmail,
  loginViaPassword,
  triggerLoginOTP,
  loginViaOTP,
  forgotPassword,
} from "../../utils/actions/loginActions";
import { useNavigate } from "react-router-dom";
import { Loading } from "../../component/Loading";
import jwt_decode from 'jwt-decode';
import qs from 'query-string';
import { numberInputOnWheelPreventChange } from '../../utils/helper'
import { firebaseSignOnLoginSuccess } from "../../utils/firebase";
import { getOrginizationDetails } from "../../utils/actions/userActions";
import { useInstance } from "../../context/instance.context";
import { allInstanceData } from "../../config";

const Login = () => {
  const { state } = useLocation();
  console.log("State :", state);
  const navigate = useNavigate();
  let token = localStorage.getItem('Token');
  const instance = useInstance();
  console.log("Instance :", instance);
  let decode;
  let pathAfterLogin = state?.pathAfterLogin;
  if (pathAfterLogin) {
    localStorage.setItem("pathAfterLogin", JSON.stringify(pathAfterLogin))
  }

  const [values, setValues] = useState({
    email: "",
    password: "",
    firstName: "",
    lastName: "",
    companyName: "",
    companySiteId: "",
    companySite: "",
    otp: "",
    suppierRefId: '',
    supplierCompany: '',
  });

  const isNdcs = allInstanceData?.NDCS == instance.name

  const [emailCheck, setEmailCheck,] = useState({});
  const [isEmailCheck, setIsEmailCheck,] = useState(false);
  const [showPassword, setShowPassword,] = useState(false);
  const [showOtp, setShowOtp,] = useState(false);
  const [isRegistered, setIsRegistered,] = useState(false);
  const [otpTriggered, setOtpTriggered,] = useState(false);
  const [check, setCheck,] = useState(true);

  const { search, } = window.location;
  const param = qs.parse(search);
  const [logoUrl, setLogoUrl] = useState(false);

  // console.log(search);

  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });
  const [isloading, setIsLoading] = useState(false);


  useEffect(() => {
    (async () => {
      try {
        console.log("run ");
        const response = await getOrginizationDetails();
        if (!response || !response.success) {
          throw new Error(response.message);
        }
        const { data } = response;
        setLogoUrl(data.organizationLogo);

      } catch (error) {
        console.log("Error :", error);
      }


    })()
  }, []);

  const isValidEmail = () => {
    let regex = new RegExp('[a-z0-9]+@[a-z]+\.[a-z]{2,3}');
    return regex.test(values.email);
  }

  const checkIsEmail = async () => {
    if (!isValidEmail()) {
      toast.error('Please enter the valid email address');
      return false;
    }
    setIsLoading(true);
    try {
      const payload = {
        email: values.email,
        supplierRefId: Number(values.suppierRefId),
      }
      const response = await checkEmail({ payload });
      if (response.statuscode !== 200) {
        toast.error(response.message);
        setIsLoading(false);
        return;
      }

      setEmailCheck(response.data);
      setValues({
        ...values,
        supplierCompany: response.data?.supplierCompany,
      })


      setIsEmailCheck(true);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      let message =
        err && err.message ? err.message : "Something went wrong during login";
      toast.error(message);
      return false;
    }
  };


  const loginPassword = async () => {
    setIsLoading(true);
    try {
      let response;
      if (otpTriggered) {
        const payload = {
          email: values.email,
          otp: values.otp,
          signedInFor7Days: check,
        }
        if (!values.otp) {
          toast.error('Please enter the OTP');
          setIsLoading(false);
          return;
        }
        response = await loginViaOTP({ payload });
      } else {
        const payload = {
          email: values.email,
          password: values.password,
          signedInFor7Days: check,
        }

        if (!values.password) {
          toast.error('Please enter the password');
          setIsLoading(false);
          return;
        }

        response = await loginViaPassword({ payload });
      }
      if (response.statuscode === 200) {
        toast.success(response.message);
        firebaseSignOnLoginSuccess();
        localStorage.setItem("Token", JSON.stringify(response?.data?.token));
        localStorage.setItem(
          "firstName",
          response?.data?.firstName
        );
        localStorage.setItem(
          "lastName",
          response?.data?.lastName
        );
        localStorage.setItem("email", response?.data?.email);
        localStorage.setItem("_id", response?.data?._id);
        localStorage.setItem("isLoggedIn", true);
        localStorage.setItem("7DayLogin", check);
        localStorage.setItem('supplierId', response?.data?.supplierId)
        if (check) localStorage.setItem("tokenValidTill", new Date(Date.now() + 86400000 * 7).valueOf());
        else sessionStorage.setItem("isLoggedIn", true);
        firebaseSignOnLoginSuccess();
        navigate(state?.from ? state?.from : "/dashboard");
      } else {
        toast.error(response.message);
      }
      setIsLoading(false);
    } catch (err) {
      let message =
        err && err.message ? err.message : "Something went wrong during login";
      toast.error(message);
      setIsLoading(false);
      return false;
    }
  }

  const triggerOTP = async () => {
    setShowOtp(true);
    setIsLoading(true);
    try {
      const payload = {
        email: values.email,
      }
      const response = await triggerLoginOTP({ payload });
      setOtpTriggered(true);
      toast.success(response.message);
      setIsLoading(false);
    } catch (err) {
      let message =
        err && err.message ? err.message : "Something went wrong during login";
      toast.error(message);
      setIsLoading(false);
      return false;
    }
  }

  function checkPassword(password) {
    if (
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@@#\$%\^&\*])(?=.{6,})/.test(
        password
      )
    ) {
      return true;
    }
    return false;
  }

  const registerUser = async () => {
    const domainCheck = values.email.split("@")[1].split(".")[0];
    const blockedDomains = ['gmail', 'hotmail', 'gmx', 'protonmail', 'outlook', 'yahoo', 'live', 'mail', 'titan', 'zoho', 'aol', 'webmail', 'icloud', 'trustifi', 'guerrellamail', 'rediffmail', 'mailfence', 'yopmail'];
    let isBlockedEmail = blockedDomains.includes(domainCheck.toLowerCase());
    if (isBlockedEmail) {
      toast.error("Domain name of email id is not accepted");
      return;
    }
    setIsLoading(true);
    try {
      let payload;
      if (values.companySiteId) {
        const { email, password, firstName, lastName, companySiteId, companySite } = values;
        payload = {
          email: email,
          password: password,
          firstName: firstName,
          lastName: lastName,
          companySiteId: companySiteId,
          userCompanySite: companySite
        }
        if (!password || !firstName || !lastName || !companySiteId || !companySite) {
          toast.error('Please enter the required details');
          setIsLoading(false);
          return;
        }

        if (!checkPassword(password)) {
          toast.error('Please enter valid password');
          setIsLoading(false);
          return;
        }
      } else if (emailCheck.isAdmin) {
        const { email, firstName, lastName, } = values;
        payload = {
          email: email,
          firstName: firstName,
          lastName: lastName,
        }
        if (!firstName || !lastName) {
          toast.error('Please enter the required details');
          setIsLoading(false);
          return;
        }
      } else {
        const { email, password, firstName, lastName, companyName, } = values;
        payload = {
          email: email,
          password: password,
          firstName: firstName,
          lastName: lastName,
          companyName: companyName,
        }
        if (!password || !firstName || !lastName || !companyName) {
          toast.error('Please enter the required details');
          setIsLoading(false);
          return;
        }

        if (!checkPassword(password)) {
          toast.error('Please enter valid password');
          setIsLoading(false);
          return;
        }

      }
      const response = await registerNewUser({ payload });
      toast.success(response.message);

      setShowOtp(true);
      setOtpTriggered(true);
      setIsLoading(false);
      setIsRegistered(true);
    } catch (err) {
      let message =
        err && err.message ? err.message : "Something went wrong during login";
      toast.error(message);
      setIsLoading(false);
      return false;
    }
  }

  // useEffect(() => {
  //   if (!token) {
  //     return;
  //   }
  //   else if (token) {
  //     decode = jwt_decode(token);
  //     if (!decode) {
  //       navigate('/');
  //     }
  //     else if (decode) {
  //       if (decode.userType == 'user') {
  //         if (param.redirect_url) {
  //           // console.log('---------test3-----------',param.redirect_url)
  //           navigate(`${param.redirect_url}${search}`, { replace: true });
  //         } else {
  //           navigate("/dashboard", { replace: true });
  //         }
  //       }
  //       else if (decode.userType == 'admin') {
  //         if (param.redirect_url) {
  //           // console.log('---------test4-----------',param.redirect_url)
  //           navigate(`${param.redirect_url}${search}`, { replace: true });
  //         } else {
  //           navigate("/admin", { replace: true });
  //         }
  //         // toast.error('Unauthorized Access!');
  //       }
  //       else {
  //         navigate('/');
  //         // toast.error('Unauthorized Access!');
  //       }
  //     }
  //   }
  //   return;
  // }, [])

  const isShow = () => {
    const { isNewUser, isAdmin, } = emailCheck;

    if (!isNewUser && isEmailCheck) {
      if (showPassword || showOtp) {
        return false;
      }
      return true;
    }
  }


  const onKeyDown = (e) => {
    const code = (e.keyCode ? e.keyCode : e.which);
    if (code == 13) {
      e.preventDefault()
      if (!emailCheck.isNewUser) {
        if (showPassword || showOtp)
          loginPassword()
        else {
          checkIsEmail()
        }
      } else {
        if ((otpTriggered || !emailCheck.isAdmin) && showOtp) { loginPassword() } else registerUser()
      }

    }
  }

  const resetPage = () => {
    setIsEmailCheck(false);



    setValues({
      email: "",
      password: "",
      firstName: "",
      lastName: "",
      companyName: "",
      companySiteId: "",
      companySite: "",
      otp: "",
      suppierRefId: '',
    });
    setEmailCheck({});
    setIsEmailCheck(false);
    setShowPassword(false);
    setShowOtp(false);
    setIsRegistered(false);
    setOtpTriggered(false);
    setCheck(true);
    setErrors({
      email: "",
      password: "",
    });
    setIsLoading(false);

  }

  const triggerSetPassword = async () => {
    try {
      const payload = {
        email: values.email,
      }
      const response = await forgotPassword({ payload });
      toast.success(response.message);
      // console.log(response);
    } catch (err) {
      console.log(err);
      toast.error(response.message);
    }
  };


  return (
    <div className="login-main fixed w-full h-full !bg-newPrimaryColor">
      <div className="left-shape">
        <img src={cornerone} />
      </div>
      <div className="right-bt-shape">
        <img src={cornertwo} />
      </div>
      <div className="right-top-shape">
        <img src={cornerthree} />
      </div>
      <div className="sm-container">
        <div className="login-in" >
          <div className="log-left" style={{ textAlign: 'left' }}>
            <div className="my-12">
              {logoUrl ? <img title={instance.name} className={`${allInstanceData?._8xP == instance.name ? "h-40" : "h-10 mt-32"} !z-10 relative  `} src={logoUrl} />
:<div className={`${allInstanceData?._8xP == instance.name ? "h-40" : "h-10 mt-32"} !z-10 relative  `}></div>}            </div>
            <h2>
              Be a part of the ultimate manufacturing revolution
            </h2>
            <p>
              {instance?.organizationName || ''} holds quality & lead time commitment in its highest regard and actively works with its partners to match the level of commitment to delivering only the best to our customers.
            </p>
            <div className="log-points">
              <ul>
                <li>
                  <span className="icon">
                    <img src={tick} />
                  </span>{" "}
                  Grow and expand with us.
                </li>
                <li>
                  <span className="icon">
                    <img src={tick} />
                  </span>{" "}
                  A seamless and transparent collaboration
                </li>
                <li>
                  <span className="icon">
                    <img src={tick} />
                  </span>{" "}
                  Leverage the power of Digital Manufacturing.
                </li>
              </ul>
            </div>
          </div>
          <div className="log-right">
            <div className='change-login'>
              <div className="form-heading">Sign in to your account</div>
            </div>
            <form className="login-form-bx">
              <div className="mb-3">
                {
                  isEmailCheck && <div onClick={() => resetPage()}>
                    <label htmlFor="exampleInputEmail1" className="form-label-email" style={{ textAlign: 'right', width: '100%' }}>Not your email ? Click here</label>
                  </div>
                }

                <div className='email-and-change-container'>
                  <label htmlFor="exampleInputEmail1" className="form-label-email">
                    Email
                  </label>
                  <label htmlFor="exampleInputEmail1" className="form-label-supplier-id">
                    Supplier ID
                  </label>
                </div>
                <div className='email-input-container'>
                  <input
                    autoComplete="username"
                    type="email"
                    className="form-control"
                    id="exampleInputEmails1"
                    placeholder="Email"
                    aria-describedby="emailHelp"
                    value={values.email}
                    style={{ width: '75%' }}
                    disabled={isEmailCheck}
                    onChange={(e) => {
                      setValues({ ...values, email: e.target.value });
                    }}
                    onKeyDown={(e) => onKeyDown(e)}
                  />
                  <input
                    autoComplete="username"
                    type="number"
                    className="form-control"
                    id="exampleSupplierId"
                    placeholder="Supplier ID (e.g., 1)"
                    aria-describedby="emailHelp"
                    value={values.suppierRefId}
                    disabled={isEmailCheck}
                    onWheel={numberInputOnWheelPreventChange}
                    style={{ width: '50%', marginLeft: '8px' }}
                    onChange={(e) => {
                      setValues({ ...values, suppierRefId: e.target.value });
                    }}
                    onKeyDown={(e) => {
                      const code = (e.keyCode ? e.keyCode : e.which);
                      if (code == 13) {
                        e.preventDefault()
                        if (!emailCheck.isNewUser) {
                          if (showPassword || showOtp)
                            loginPassword()
                          else {
                            checkIsEmail()
                          }
                        } else {
                          if ((otpTriggered || !emailCheck.isAdmin) && showOtp) { loginPassword() } else registerUser()
                        }

                      }
                      ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
                    }}
                  />
                </div>
                {errors.email && <span className="error">{errors.email}</span>}
              </div>

              {
                (isEmailCheck && emailCheck.isNewUser && !emailCheck.isAdmin && !showOtp) || showPassword ? (
                  <div className="mb-3">
                    <div className='email-and-change-container'>
                      <label htmlFor="exampleInputPassword1" className="form-label">
                        {
                          emailCheck.isNewUser ? 'Set Password' : 'Password'
                        }
                      </label>
                      {!emailCheck.isNewUser && <label htmlFor="exampleInputEmail1" className="form-label-email" onClick={triggerSetPassword} style={{ textAlign: 'right', width: '100%' }}>Forgot Password ? Click here</label>}
                    </div>
                    <input
                      autoComplete="current-password"
                      type="password"
                      className="form-control"
                      id="exampleInputPassword1"
                      placeholder="Enter here"
                      value={values.password}
                      onChange={(e) => {
                        setValues({ ...values, password: e.target.value });
                      }}
                      onKeyDown={(e) => onKeyDown(e)}
                    />
                    {/* 
                    Not required in supplier context
                    {
                      emailCheck.isNewUser && (
                        <div className="password-validation">
                          <p>
                            A minimum 6 characters password contains a combination of{" "}
                          </p>
                          <ul>
                            <li>uppercase and lowercase letter </li>
                            <li>number </li>
                            <li>At least 1 special character.</li>
                          </ul>
                        </div>
                      )
                    } */}
                  </div>
                ) : null
              }

              {
                showOtp ? (
                  <div className="mb-3" style={{ textAlign: 'left' }}>
                    <label className="form-label">
                      Enter OTP
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="exampleInputPassword1"
                      placeholder="Enter here"
                      value={values.otp}
                      onWheel={numberInputOnWheelPreventChange}
                      onChange={(e) => {
                        setValues({ ...values, otp: e.target.value });
                      }}
                      onKeyDown={(e) => onKeyDown(e)}
                    />
                    <div className="mt-2 resend-otp-container">
                      <span className='resend-otp' onClick={triggerOTP}>Resend OTP</span>
                    </div>
                    {errors.password && (
                      <span className="error">{errors.password}</span>
                    )}
                  </div>
                ) : null
              }


              {
                isShow() && (
                  <div className='login-btn'>
                    {
                      emailCheck?.isVerified ? <div className='btn-submit' style={{ cursor: 'pointer' }} onClick={() => setShowPassword(true)}>Login via Password</div> : null
                    }
                    <div className='btn-submit' style={{ cursor: 'pointer' }} onClick={triggerOTP}>Login via OTP</div>
                  </div>
                )
              }


              <div className="mb-3">

                <div className="check-signup">
                  <p>
                    By signing in, you confirm that you've read and accepted our{" "}
                    {
                      !isNdcs ? <a
                        href={process.env.REACT_APP_TERMS_AND_CONDITIONS_URL}
                        className="text-primaryColor underline"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Terms of Service
                      </a> : <Link to="/terms-of-service" className="text-primaryColor underline" state={{ from: "login" }}>
                        Terms of Services{" "}
                      </Link>
                    }

                    {" "} and{" "}
                    {
                      !isNdcs ? <a
                        href={process.env.REACT_APP_PRIVACY_URL}
                        className="text-primaryColor underline"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Privacy Policy
                      </a> : <Link to="/privacy-policy" className="text-primaryColor underline" state={{ from: "login" }}>
                        Privacy Policy
                      </Link>}
                  </p>
                </div>
              </div>
              {isloading ? (
                <Loading />
              ) : (
                !emailCheck.isNewUser ? (
                  !isShow() && <div
                    href='#'
                    className="btn-submit"
                    style={{ cursor: 'pointer' }}
                    onClick={(showPassword || showOtp) ? loginPassword : checkIsEmail}
                  >
                    Submit
                  </div>
                ) : (
                  <div
                    href='#'
                    className="btn-submit"
                    onClick={(otpTriggered || !emailCheck.isAdmin) && showOtp ? loginPassword : registerUser}
                  >
                    Submit
                  </div>
                )
              )}
            </form>
            {
              (showPassword || showOtp) && (
                <div className='change-login'>
                  <div className='signin-week'>
                    <input type='checkbox' checked={check} onChange={() => setCheck(!check)} />
                    <div className='signin-text'>Stay signed in for a week</div>
                  </div>
                  <div style={{ marginTop: '15px' }}>
                    {
                      isEmailCheck && (showPassword || showOtp) && !emailCheck.isNewUser && !emailCheck.isAdmin && <div onClick={!showPassword ? () => { setShowPassword(true); setShowOtp(false); setOtpTriggered(false) } : () => { triggerOTP(); setShowPassword(false) }} className='login-text'>{(!showPassword && !emailCheck.isNewUser) ? 'Login via Password' : 'Login via OTP'}</div>
                    }
                  </div>
                </div>
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
};
export default Login;
